export const NBOX_CREW_ID = 465;
export const NESS_CREW_ID = 539;
export const SOOP_MARPPLESHOP_CREW_ID = 547;

export const SOOP_MARPPLESHOP_CREW_DOMAIN =
  (typeof G == 'undefined' ? {} : G)?.SOOP_DOMAIN_NAME ?? 'sooptore';

export const EXCLUDE_CREW_IDS = [1, NBOX_CREW_ID, NESS_CREW_ID, SOOP_MARPPLESHOP_CREW_ID];
